import axios from 'axios'
let route = process.env.VUE_APP_API_ROUTE + '/acc_purchase_sale_book'

const createPurchaseSaleBook = async (object) => {
    try {
        const response = await axios.post(
            route,
            object
        )
        return response.data
    } catch (error) {
        error.response.data
    }
}

export { createPurchaseSaleBook }
